<template>
  <div id="app">
    <router-view name="header"></router-view>
    <main>
        <fade-transition origin="center" mode="out-in" :duration="250">
            <keep-alive :include="['INewsList']">
                <router-view v-wechat-title="$route.meta.title" ></router-view>
            </keep-alive>
        </fade-transition>
    </main>
    <router-view name="footer"></router-view>
  </div>
</template>

<script>
import { FadeTransition } from "vue2-transitions";

export default {
  name: 'app',
  components: {
    FadeTransition,
  }
}
</script>
<style>
  #app{
        background-color: rgb(240, 240, 240);
        -webkit-overflow-scrolling: touch;
  }
</style>
